import { render, staticRenderFns } from "./su-page.vue?vue&type=template&id=72252ce5"
import script from "./su-page.vue?vue&type=script&lang=js"
export * from "./su-page.vue?vue&type=script&lang=js"
import style0 from "./su-page.vue?vue&type=style&index=0&id=72252ce5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports